import React from 'react';
import { motion } from 'framer-motion';

export default function BoltShiningText({ text }) {
  return (
    <motion.span
      className="bolt-shining-text"
      initial={{ backgroundPosition: '200% 0' }}
      animate={{ backgroundPosition: '-200% 0' }}
      transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'linear',
      }}
    >
      {text}
    </motion.span>
  );
}
